import { createContext, ReactNode, useContext } from 'react'
import { Field } from 'formik'
import { css, StyleSheet } from 'aphrodite'
import { cn } from '../utils/classname'
import ValidationErrorMessage from './ValidationErrorMessage'

const Context = createContext({ name:'' })

export type Props = {
    label?: string | null
    value: string | number
}

export function Radio({ label = null, value }: Props) {
    const { name } = useContext(Context)

    return (
        <label className="radio">
            <Field type="radio" name={name} value={value} className={css(styles.input)} />
            {label || null}
        </label>
    )
}

export type GroupProps = {
    name: string
    children?: ReactNode
}

export function RadioGroup({ name, children }: GroupProps) {
    return (
        <div className={cn('control', css(styles.group))}>
            <Context.Provider value={{ name }}>
                {children}
            </Context.Provider>

            <ValidationErrorMessage name={name} />
        </div>
    )
}

const styles = StyleSheet.create({
    input: {
        marginRight: '0.3rem',
    },
    group: {
        marginBottom: '1rem',
    },
})
